import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';

function CompaniesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [search, setSearch]     = useState('');

  useEffect(() => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/companies`)
      .then(res => setCompanies(res.data?.companies || res.data || []))
      .catch(() => setError('Failed to load companies.'))
      .finally(() => setLoading(false));
  }, [location]);

  const filtered = companies.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.country?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Companies</h1>
        <p className="page-subtitle">
          {loading ? 'Loading…' : `${filtered.length} compan${filtered.length !== 1 ? 'ies' : 'y'}`}
        </p>
        <a className="btn-secondary" style={{ marginTop: 6, display: 'inline-block', textDecoration: 'none' }}
           href={`${API_BASE_URL}/pipeline/export.csv`}
           title="Your programs compared against each company's pipeline page (checked weekly)">
          Export CSV: all companies
        </a>
      </div>

      <div className="page-body">
        <div className="filter-bar">
          <input
            type="text"
            placeholder="Search companies…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        {error && <div className="error-state">{error}</div>}

        {loading && <div className="loading-state">Loading companies…</div>}

        {!loading && !error && (
          <div className="companies-grid">
            {filtered.length === 0 ? (
              <p style={{ color: '#94a3b8', gridColumn: '1 / -1' }}>No companies found.</p>
            ) : (
              filtered.map(company => (
                <div
                  key={company.id}
                  className="company-card"
                  onClick={() => navigate(`/pipeline/companies/${company.id}`)}
                >
                  <div className="company-card-name">{company.name}</div>
                  <div className="company-card-country">{company.country || 'Unknown country'}</div>
                  <div className="company-card-stats">
                    <div className="company-card-stat">
                      <span className="company-card-stat-value">
                        {company.program_count ?? company.programs_count ?? '—'}
                      </span>
                      <span className="company-card-stat-label">Programs</span>
                    </div>
                    <div className="company-card-stat">
                      <span className="company-card-stat-value">
                        {company.trial_count ?? company.trials_count ?? '—'}
                      </span>
                      <span className="company-card-stat-label">Trials</span>
                    </div>
                    {(company.filing_count ?? company.filings_count) != null && (
                      <div className="company-card-stat">
                        <span className="company-card-stat-value">
                          {company.filing_count ?? company.filings_count}
                        </span>
                        <span className="company-card-stat-label">Filings</span>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default CompaniesPage;
